import * as _4 from 'lodash4';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';
import { SurveyStepService } from '../../data/services/survey_step_service';

export class MajorSortFilterController {
  private filteredProgramEnum: any[];
  private sortFilters: string[];
  private headerTheme: string;
  private filterExpanded: boolean = false;

  constructor(
    private ngSurveyStepService: SurveyStepService,
    private programSortEnum: any,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {
    this.configureSortFilters();
    if (this.ngMajorExplorerCapabilityConfiguration.config.navIconTheme) {
      this.headerTheme = this.ngMajorExplorerCapabilityConfiguration.config.navIconTheme;
    }
  }

  configureSortFilters(): void {
    this.filteredProgramEnum = [];
    _4.forEach(this.programSortEnum.iterator(), (sortEnum: any) => {
      if (sortEnum.enabled()) {
        this.filteredProgramEnum.push(sortEnum);
      }
    });

    this.sortFilters = _4.map(this.filteredProgramEnum, (sortEnum: any) => sortEnum.actionSheetText);
  }

  changeFilter(index: number): void {
    this.ngSurveyStepService.sortPrograms(this.filteredProgramEnum[index].key);
  }

  toggleFilter() {
    this.filterExpanded = !this.filterExpanded;
  }
}

export class MajorSortFilterComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-major-explorer/src/components/major_sort_filter/major_sort_filter.html';
  public controller: any = MajorSortFilterController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_sort_filter/major_sort_filter_controller.ts